import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class QuotaMovementsBatchService extends ApiService {
  constructor(private http: Http) {
    super('api/movements-batchs/', http);
  }

  public add_line(batchId, data): Observable<Object> {
    const url = this.apiUrl + `api/movements-batchs/${batchId}/add_line/`;
    return this.http.post(url, data, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public consolidate(id: number): Observable<Object> {
    const url = this.apiUrl + `api/movements-batchs/${id}/consolidate/`;
    return this.http.post(url, {}, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public downloadExcel(token: string, id: number) {
    const xAssociation = localStorage.getItem('x-association') || 0;
    const url = `${this.apiUrl}${this.endpointUrl}${id.toString()}/download/?token=${token}&x-association=${xAssociation}`;
    location.assign(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/quota-movements-batch.service.ts